/* eslint-disable import/prefer-default-export */
/* eslint-disable no-nested-ternary */
/* eslint-disable default-case */
import { useState } from 'react';
import { allOptions } from './chip-select';
function getAllSelected(options) {
    return options.filter((opt) => !opt.all).map((opt) => opt.value);
}
export function useChipSelect({ defaultSelected, callback, options }) {
    const [selected, setSelected] = useState(defaultSelected || []);
    function selectOneOrAll({ value, label, all }) {
        setSelected(all ? getAllSelected(options) : [value]);
        if (callback) {
            callback({ value, label, all });
        }
    }
    function selectMultiBase(withAllButton, { value, label, all }) {
        if (all) {
            setSelected(getAllSelected(options));
        }
        else if (allOptions(options, selected) && withAllButton) {
            setSelected([value]);
        }
        else {
            setSelected(selected.includes(value)
                ? selected.filter((sel) => sel !== value)
                : [...selected, value]);
        }
        if (callback) {
            callback({ value, label, all });
        }
    }
    function selectOne({ value, label, all }) {
        setSelected(value);
        if (callback) {
            callback({ value, label, all });
        }
    }
    return {
        selected,
        selectOneOrAll,
        selectMulti: (args) => selectMultiBase(false, args),
        selectMultiOrAll: (args) => selectMultiBase(true, args),
        selectOne,
    };
}
